// src/app/components/countdown/countdown.component.ts
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

@Component({
  selector: 'app-countdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.css'],
})
export class CountdownComponent implements OnInit, OnDestroy {
  @Input() targetDate: string = '';
  @Input() label: string = '';
  @Input() theme: 'green' | 'gold' | 'dark' = 'green';

  timeLeft: TimeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
  expired = false;
  private interval: any;

  ngOnInit(): void {
    this.calculate();
    this.interval = setInterval(() => this.calculate(), 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  private calculate(): void {
    const diff = new Date(this.targetDate).getTime() - Date.now();
    if (diff <= 0) {
      this.expired = true;
      this.timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
      return;
    }
    this.timeLeft = {
      days:    Math.floor(diff / 86400000),
      hours:   Math.floor((diff % 86400000) / 3600000),
      minutes: Math.floor((diff % 3600000) / 60000),
      seconds: Math.floor((diff % 60000) / 1000),
    };
  }

  pad(n: number): string {
    return n.toString().padStart(2, '0');
  }
}
